<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/syRIr6/tc-custom/9781467450492.jpg?1728851880261" alt="This image is the cover for the book Faith and Fossils"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Faith and Fossils
      </h1>
      <p class="bookDescription body article font2">
        <p>Many books have been written on the Bible and evolution by scientists, but this volume is written by a biblical specialist. In <i>Faith and Fossils</i> Lester Grabbe, a prominent Hebrew Bible scholar, examines the Bible in its ancient context and explores its meaning in light of emerging scientific evidence. </p><p>Both the Bible and the fossil record raise significant questions about what it means to be human, and Grabbe expertly draws on both sources to grapple with who we are and where we came from. Written in uncomplicated language and featuring eleven spectacular color plates, Grabbe’s <i>Faith and Fossils</i>creatively shows how science and faith intersect in questions about human origins.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lester L. Grabbe
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Lester L. Grabbe</B>&#160;is Professor Emeritus of Hebrew Bible and Early Judaism at the University of Hull. His other books include&#160;<I>Ancient Israel: What Do We Know and How Do We Know It?</I>&#160;(second edition).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0abbe45d